import { StackIcon } from "@xola/icons";
import { almostZero, Badge, Tooltip } from "@xola/ui-kit";
import clsx from "clsx";
import React from "react";
import { Currency } from "../../Common/Currency";

interface BalanceBadgeProps {
    value: number;
    size?: string;
    className?: string;
    color?: string;
    showValueInTooltip?: boolean;
    onClick?: (e: any) => void;
}

export const BalanceBadge = ({
    value,
    size = "small",
    color = "danger",
    showValueInTooltip = false,
    className,
    onClick,
}: BalanceBadgeProps) => {
    if (almostZero(value)) {
        return null;
    }

    return (
        <Tooltip content={<Currency>{value}</Currency>} disabled={!showValueInTooltip}>
            <Badge
                color={color}
                icon={<StackIcon />}
                size={size}
                className={clsx("ui-dashboard-balance cursor-pointer tracking-tightest", className)}
                onClick={onClick}
            >
                {!showValueInTooltip && <Currency>{value}</Currency>}
            </Badge>
        </Tooltip>
    );
};
